import { render, staticRenderFns } from "./ControlsMobile.vue?vue&type=template&id=568fc495&scoped=true&lang=pug&"
import script from "./ControlsMobile.vue?vue&type=script&lang=js&"
export * from "./ControlsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568fc495",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
